import { Chip, Tooltip } from "@mui/material";
import { Error } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "../../app/hooks";
import { LogSearchKind, Role } from "../../app/backendTypes";

function ErrorChip(props: { error: string; inLable?: boolean }) {
  const { error, inLable = false } = props;

  const auth = useAppSelector((state) => state.auth);
  const isAdmin = auth.roles.includes(Role.Administrator);

  const nagivate = useNavigate();

  const chip = (
    <Chip
      label={inLable ? error : "Error"}
      icon={<Error />}
      color="error"
      variant="outlined"
      onClick={
        isAdmin
          ? () =>
              nagivate(
                `/admin/logs?kind=${LogSearchKind.Request}&value=${error}`
              )
          : undefined
      }
    />
  );

  return (
    <>
      {inLable ? (
        chip
      ) : isAdmin ? (
        chip
      ) : (
        <Tooltip arrow placement="top" title={error}>
          {chip}
        </Tooltip>
      )}
    </>
  );
}

export default ErrorChip;
